export default "__VITE_ASSET__BSQXkPpo__"